import React, { useEffect, useState } from "react";
import { GdanskSaleForm } from "../../../models/GdanskSaleForm";
import EAMultipleChoiceChipSelector from "../../shared/ChoiceChip/EAMultipleChoiceChipSelector";
import useFacility from "../../../../utils/hooks/useFacility";
import { get } from "../../../api";
import { AssortGroup } from "../../../models/AssortGroup";
import getId from "../../../../utils/getId";
import { GET_BOOKINGGROUPS } from "../../../api/apiRoutes";
import EATooltip from "../../shared/EATooltip/EATooltip";

interface IProps {
  form: GdanskSaleForm;
  setForm: (form: GdanskSaleForm) => void;
}

const GdanskBookingGroupInput: React.FC<IProps> = ({ form, setForm }) => {
  const facilityIds = useFacility();
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState<{ value: string; label: string; icon?: React.ReactNode }[]>([]);

  const getBookingGroups = async () => {
    setLoading(true);
    const { result, isError } = await get(GET_BOOKINGGROUPS(facilityIds));
    if (!isError) {
      const newResult = result.map((item: AssortGroup) => {
        const description = item.description?.trim().toUpperCase();

        let tooltipText: string | null = null;
        if (description === "MIESIĘCZNY") tooltipText = "Miesięczny";
        if (description === "KWARTALNY") tooltipText = "Kwartalny";
        if (description === "PÓŁROCZNY") tooltipText = "Półroczny";
        if (description === "ROCZNY") tooltipText = "Roczny";

        return {
          value: getId(item),
          label: item.name,
          icon: tooltipText ? (
            <EATooltip content={tooltipText}>
              <span className="gdansk-tooltip-icon">i</span>
            </EATooltip>
          ) : undefined,
        };
      });
      setOptions(newResult);
    }
    setLoading(false);
  };

  useEffect(() => {
    getBookingGroups();
    //eslint-disable-next-line
  }, []);

  return (
    <div className="gdansk-input-content">
      <h5 className="no-line-height">Ile takich rezerwacji chcesz wykonać do przodu</h5>
      <EAMultipleChoiceChipSelector
        options={options ?? []}
        selectedValue={form.bookingGroupIds}
        onSelect={(value, label) => setForm({ ...form, bookingGroupIds: value, bookingGroupName: label })}
        chipSize="small"
        loading={loading}
        width="70%"
      />
    </div>
  );
};

export default GdanskBookingGroupInput;
